export default "__VITE_ASSET__CarzsXG2__"